document.addEventListener('DOMContentLoaded', function () {

  function hideSoldOutVariants() {
    // Targetează input-urile radio cu clasa "disabled" (specific Craft)
    document.querySelectorAll('.product-form__input--pill input[type="radio"].disabled').forEach(function(input) {
      // Ascunde input-ul
      input.style.display = 'none';
      // Ascunde și label-ul asociat
      var label = document.querySelector('label[for="' + input.id + '"]');
      if (label) label.style.display = 'none';
    });
  }

  hideSoldOutVariants();
  setTimeout(hideSoldOutVariants, 500);
  setTimeout(hideSoldOutVariants, 1500);

});
